import React from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";

import { getPersonFullName } from "utils/person";
import { transformViewDate } from "utils/date-utils";
import { TExamNote } from "../../types";

import useStyles from "./styles";

interface IProps {
  readOnly: boolean;
  disabled?: boolean;
  isNoteExists: boolean;
  onOpen: (e: React.SyntheticEvent) => void;
  examNote: TExamNote;
  noteLabel?: string;
}

const ExamNoteLabel = (props: IProps) => {
  const {
    readOnly,
    disabled = false,
    isNoteExists,
    onOpen,
    examNote,
    noteLabel = "Exam Reason Note"
  } = props;

  const classes = useStyles();

  const renderLabel = () => {
    if (!readOnly) {
      return (
        <Button
          className={classes.editNoteButton}
          variant="text"
          disableRipple
          disabled={disabled}
          onClick={onOpen}
        >
          {isNoteExists ? noteLabel : `Add ${noteLabel}`}
        </Button>
      );
    } else if (isNoteExists) {
      return <span className={classes.noteLabel}>{noteLabel}</span>;
    }
  };

  return (
    <>
      {renderLabel()}
      {isNoteExists && (
        <>
          <span className={classes.details}>
            <span className={classes.separator}>{" - "}</span>
            {getPersonFullName(examNote.notedBy, "%f %L")}{" "}
            {transformViewDate(
              examNote.notedOn,
              undefined,
              "MM/dd/yyyy - hh:mm aa"
            )}
          </span>
          <p className={classes.body}>{examNote.body}</p>
        </>
      )}
    </>
  );
};

export default ExamNoteLabel;
